import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getPendingSelfPromotionsService() {
  return axios
    .get(`${BASE_URL}/self-promotion/pending`)
    .then(({ data }) => data);
}

export function answerSelfPromotionService(cycleId, rank, answer) {
  return axios
    .post(`${BASE_URL}/self-promotion/answer`, {
      cycleId,
      rank,
      answer,
    })
    .then(({ data }) => data);
}
